import { getFlagFromCountryName } from "../../utils/getFlags";

const CountryDropdownItem = ({ countryName }: { countryName: string }) => {
	return (
		<div style={{ display: "flex", alignItems: "center" }}>
			{getFlagFromCountryName(countryName.toUpperCase()) ? (
				<img
					src={getFlagFromCountryName(countryName.toUpperCase())}
					alt={countryName}
					style={{
						width: "15px",
						height: "15px",
						borderRadius: "50%",
						marginRight: "4px",
						objectFit: "cover"
					}}
				/>
			) : (
				<div style={{ width: "15px", height: "15px", borderRadius: "50%", marginRight: "4px" }} />
			)}
			{countryName}
		</div>
	);
};

export default CountryDropdownItem;
